import { threeDecimal, twoDecimal } from "./helperFunctions";

export const labellStock = ({ entry, data }) => {
  const stones = entry?.stones?.length ? entry?.stones?.map((sitem)=>{
    return {
      ...sitem,
       stnPopupAmt:twoDecimal(sitem?.stnPopupAmt),
       stnPopupWt:threeDecimal(sitem?.stnPopupWt),
       stnPopupRateByPcs:twoDecimal(sitem?.stnPopupRateByPcs),
       stnPopupRateByWt:twoDecimal(sitem?.stnPopupRateByWt),
    }
  }) :[]

  return {
    status: "active",
    vendorName: data?.vendor?.label || "", // Vendor Name from the vendor object
    vendorId: data?.vendor?.value || "", // Vendor ID from the vendor object
    branchId: data?.branch?.value || "", // Branch ID from the branch object
    branchName: data?.branch?.label || "",
    categoryId: entry?.category?.value || "",
    categoryName: entry?.category?.label || "",
    productId: entry?.product?.value || "",
    productName: entry?.product?.label || "",
    designId: entry?.design?.value || "",
    designName: entry?.design?.label || "",
    purityId: entry?.purity?.value || "",
    purityName: entry?.purity?.label || "",
    totalWt: threeDecimal(entry?.totalWt),
    packingWt:  threeDecimal(entry?.packingWt),
    grossWt: threeDecimal(entry?.grossWt),
    stoneWt: threeDecimal(entry?.stoneWt),
    diamondWt: threeDecimal(entry?.diamondWt),
    netWt: threeDecimal(entry?.netWt),
    pcs:entry?.pcs || "",
    stonePcs:entry?.stonePcs || "",
    diamondPcs:entry?.diamondPcs || "",
    totalStoneAmount:entry?.totalStoneAmount || "",
    totalDiamondAmount:entry?.totalDiamondAmount || "",
    makingPercentage:entry?.makingPercentage || "",
    makingPerGram:entry?.makingPerGram || "",
    fixedMaking:entry?.fixedMaking || "",
    fixedAmount:entry?.fixedAmount || "",
    mrp:entry?.mrp || "",
    sampleName:entry?.sampleName || "",
    description:entry?.description || "",
    hallmarkCharge:entry?.hallmarkCharge || "",
    huidCode:entry?.huidCode || "",
    stones:stones

    

   
    // itemCode: entry?.itemCode || "",
  };
};

export const unlabelledStock = ({entry,data})=>{
  return {
     vendorName: data?.vendor?.label || "", // Vendor Name from the vendor object
    vendorId: data?.vendor?.value || "", // Vendor ID from the vendor object
    branchId: data?.branch?.value || "", // Branch ID from the branch object
    branchName: data?.branch?.label || "",
     categoryId: entry?.category?.value || "",
    categoryName: entry?.category?.label || "",
    productId: entry?.product?.value || "",
    productName: entry?.product?.label || "",
    designId: entry?.design?.value || "",
    designName: entry?.design?.label || "",
    purityId: entry?.purity?.value || "",
    purityName: entry?.purity?.label || "",
     totalWt: threeDecimal(entry?.totalWt),
    packingWt:  threeDecimal(entry?.packingWt),
    grossWt: threeDecimal(entry?.grossWt),
    stoneWt: threeDecimal(entry?.stoneWt),
    diamondWt: threeDecimal(entry?.diamondWt),
    netWt: threeDecimal(entry?.netWt),
    qty:entry?.qty,
    finePercentage:entry?.finePercentage,
    wastagePercentage:entry?.wastagePercentage,
    fineWastageWt:entry?.fineWastageWt
  }
}

export function inflateManyToFormDefaults(items = [], top = {}) {
  const opt = (value, label) => (value ? { value, label: label ?? value } : null);

  return items?.map((item)=>{
    return {
      category: opt(item.categoryId, item.categoryName),
      product:  opt(item.productId,  item.productName),
      design:   opt(item.designId,   item.designName),
      purity:   opt(item.purityId,   item.purityName),

      totalWt:          item.totalWt ?? "",
      packingWt:        item.packingWt ?? "",
      grossWt:          item.grossWt ?? "",
      stoneWt:          item.stoneWt ?? "",
      diamondWt:        item.diamondWt ?? "",
      netWt:            item.netWt ?? "",

      pcs:              item.pcs ?? "",
      stonePcs:         item.stonePcs ?? "",
      diamondPcs:       item.diamondPcs ?? "",

      totalStoneAmount: item.totalStoneAmount ?? "",
      totalDiamondAmount: item.totalDiamondAmount ?? "",

      makingPercentage: item.makingPercentage ?? "",
      makingPerGram:    item.makingPerGram ?? "",
      fixedMaking:      item.fixedMaking ?? "",
      fixedAmount:      item.fixedAmount ?? "",
      mrp:              item.mrp ?? "",

      sampleName:       item.sampleName ?? "",
      description:      item.description ?? "",
      itemCode:         item.itemCode,
  }
})}

